export const ACTIVITY_TYPES = [
	'Переработка',
	'Дистрибуция/опт',
	'Добыча/вылов',
	'Импорт/экспорт',
	'Смешанный тип',
] as const;

export type ActivityType = (typeof ACTIVITY_TYPES)[number];

export type ProfileKey =
	| 'labor'
	| 'storage'
	| 'capital'
	| 'deferred'
	| 'badDebt'
	| 'expired'
	| 'markdown'
	| 'weight'
	| 'returns'
	| 'site'
	| 'marketer'
	| 'ads'
	| 'articles'
	| 'ai'
	| 'exhibitions'
	| 'b2b';

/** Профильные множители по типу РК: эффективный коэффициент = базовый × множитель (не более 100%) */
export const PROFILE_MULTIPLIERS: Record<ProfileKey, Record<ActivityType, number>> = {
	labor: {
		Переработка: 1.0,
		'Дистрибуция/опт': 1.1,
		'Добыча/вылов': 0.9,
		'Импорт/экспорт': 1.2,
		'Смешанный тип': 1.0,
	},
	storage: {
		Переработка: 1.0,
		'Дистрибуция/опт': 0.8,
		'Добыча/вылов': 1.3,
		'Импорт/экспорт': 1.1,
		'Смешанный тип': 1.0,
	},
	capital: {
		Переработка: 1.0,
		'Дистрибуция/опт': 0.8,
		'Добыча/вылов': 1.3,
		'Импорт/экспорт': 1.1,
		'Смешанный тип': 1.0,
	},
	deferred: {
		Переработка: 1.0,
		'Дистрибуция/опт': 1.1,
		'Добыча/вылов': 0.9,
		'Импорт/экспорт': 1.2,
		'Смешанный тип': 1.0,
	},
	badDebt: {
		Переработка: 0.9,
		'Дистрибуция/опт': 1.0,
		'Добыча/вылов': 0.8,
		'Импорт/экспорт': 1.1,
		'Смешанный тип': 1.0,
	},
	expired: {
		Переработка: 1.3,
		'Дистрибуция/опт': 0.9,
		'Добыча/вылов': 1.0,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	markdown: {
		Переработка: 1.3,
		'Дистрибуция/опт': 0.9,
		'Добыча/вылов': 1.0,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	weight: {
		Переработка: 0.8,
		'Дистрибуция/опт': 1.3,
		'Добыча/вылов': 0.9,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	returns: {
		Переработка: 0.8,
		'Дистрибуция/опт': 1.3,
		'Добыча/вылов': 0.9,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	site: {
		Переработка: 0.9,
		'Дистрибуция/опт': 1.2,
		'Добыча/вылов': 0.7,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	marketer: {
		Переработка: 0.9,
		'Дистрибуция/опт': 1.2,
		'Добыча/вылов': 0.7,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	ads: {
		Переработка: 0.9,
		'Дистрибуция/опт': 1.2,
		'Добыча/вылов': 0.7,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	articles: {
		Переработка: 0.9,
		'Дистрибуция/опт': 1.2,
		'Добыча/вылов': 0.7,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	ai: {
		Переработка: 0.9,
		'Дистрибуция/опт': 1.1,
		'Добыча/вылов': 0.8,
		'Импорт/экспорт': 1.1,
		'Смешанный тип': 1.0,
	},
	exhibitions: {
		Переработка: 1.0,
		'Дистрибуция/опт': 1.0,
		'Добыча/вылов': 0.8,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
	b2b: {
		Переработка: 1.0,
		'Дистрибуция/опт': 1.2,
		'Добыча/вылов': 0.8,
		'Импорт/экспорт': 1.0,
		'Смешанный тип': 1.0,
	},
};
